<script setup lang="ts">
import useModel from './../model/model'
import { ref } from 'vue'
import { useSendForm } from './../model/api'
import { useAuth } from '@/entities/Auth'

const model = useModel()
const { sendForm, isPending } = useSendForm()
const { isPermissions } = useAuth()

const valid = ref(false)
const { isFetching } = model.loadData()

/**
 * Функция отправки формы
 */
const submitHandler = () => {
  sendForm(model.data, model.origin, valid.value).then(model.updateOrigin)
}
</script>

<template>
  <VForm
    v-model="valid"
    class="cabinet-main-form"
    :disabled="isFetching"
    @submit.prevent="submitHandler"
  >
    <div class="form__grid_3">
      <VTextField :label="$t('itf.sim_num', { num: 1 })" v-model="model.data.sim_1" v-phone />

      <VSelect
        :label="$t('itf.gsm_profile_num', { num: 1 })"
        v-model="model.data.gsm_profile_1"
        :items="model.gsm_profiles"
        item-value="id"
        item-title="operator_name"
      />

      <VTextField
        :label="$t('itf.iccid_sim_num', { num: 1 })"
        v-model="model.data.iccid_sim_1"
        readonly
      />
    </div>

    <div class="form__grid_3">
      <VTextField :label="$t('itf.sim_num', { num: 2 })" v-model="model.data.sim_2" v-phone />

      <VSelect
        :label="$t('itf.gsm_profile_num', { num: 2 })"
        v-model="model.data.gsm_profile_2"
        :items="model.gsm_profiles"
        item-value="id"
        item-title="operator_name"
      />

      <VTextField
        :label="$t('itf.iccid_sim_num', { num: 2 })"
        v-model="model.data.iccid_sim_2"
        readonly
      />
    </div>

    <div class="form__grid_3">
      <VSelect
        :label="$t('itf.mqtt_broker')"
        v-model="model.data.unilight_broker"
        :items="model.mqtt_brokers"
        item-value="id"
        item-title="broker_name"
        :disabled="!isPermissions('PROTECT')"
      />

      <VSelect
        :label="$t('itf.npm_server_1')"
        v-model="model.data.ntp_server_1"
        :items="model.ntp_servers"
        item-value="id"
        item-title="ntp_server"
      />

      <VSelect
        :label="$t('itf.npm_server_2')"
        v-model="model.data.ntp_server_2"
        :items="model.ntp_servers"
        item-value="id"
        item-title="ntp_server"
      />
    </div>

    <div class="form__grid_3">
      <VCheckbox
        :label="$t('itf.is_ethernet')"
        v-model="model.data.is_ethernet"
        :disabled="!isPermissions(['PROTECT'])"
      />

      <VCheckbox
        :label="$t('itf.is_lora')"
        v-model="model.data.is_lora"
        :disabled="!isPermissions(['PROTECT'])"
      />

      <VCheckbox
        :label="$t('itf.sim_num', { num: 2 })"
        :true-value="2"
        :false-value="1"
        v-model="model.data.sim_card_priority"
      >
        <template #prepend>{{ $t('itf.sim_num', { num: 1 }) }}</template>
      </VCheckbox>
    </div>

    <div class="mt-4">
      <VBtn type="submit" :loading="isPending">{{ $t('itf.save') }}</VBtn>
    </div>
  </VForm>
</template>
